import { toast } from "sonner";
import { Facebook, Twitter, MessageCircle, Heart, Copy } from "lucide-react";
import { useI18n } from "@/context/Language";

export const Footer = ({ onDonate }) => {
  const { t } = useI18n();
  const F = t.footer;
  const shareUrl = typeof window !== "undefined" ? window.location.origin : "";

  const links = [
    { label: "WhatsApp", testid: "share-whatsapp", icon: MessageCircle, href: `https://wa.me/?text=${encodeURIComponent(F.shareText + " " + shareUrl)}` },
    { label: "Facebook", testid: "share-facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}` },
    { label: "X", testid: "share-x", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(F.shareText)}&url=${encodeURIComponent(shareUrl)}` },
  ];

  const copyLink = () => {
    navigator.clipboard?.writeText(shareUrl);
    toast.success(F.copyToast);
  };

  return (
    <footer className="relative bg-ink text-sand pt-24 sm:pt-32 pb-10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-4xl">
          <span className="text-xs uppercase tracking-[0.24em] text-terracotta">{F.support}</span>
          <h2 className="mt-5 font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-balance">{F.heading}</h2>
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-4">
          <button
            data-testid="footer-donate-button"
            onClick={() => onDonate()}
            className="inline-flex items-center gap-2 rounded-full bg-terracotta px-8 py-4 text-sm font-semibold text-sand transition-colors hover:bg-terracotta-hover active:scale-[0.98]"
          >
            <Heart className="h-4 w-4" fill="currentColor" />
            {F.contribute}
          </button>

          <div className="flex items-center gap-3">
            {links.map((l) => (
              <a key={l.label} data-testid={l.testid} href={l.href} target="_blank" rel="noopener noreferrer" aria-label={l.label} className="flex h-12 w-12 items-center justify-center border border-sand/20 text-sand transition-colors hover:bg-sand hover:text-ink">
                <l.icon className="h-5 w-5" />
              </a>
            ))}
            <button data-testid="share-copy" onClick={copyLink} aria-label="Copy link" className="flex h-12 w-12 items-center justify-center border border-sand/20 text-sand transition-colors hover:bg-sand hover:text-ink">
              <Copy className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="mt-16 border-t border-sand/15 pt-8" data-testid="organized-by">
          <span className="text-xs uppercase tracking-[0.24em] text-terracotta">{F.organizedBy}</span>
          <div className="mt-3 flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center border border-sand/25 px-4 py-2 text-sm text-sand/90">Iglesia Cristiana Ríos de Agua Viva</span>
            <span className="font-serif text-lg text-sand/90">{F.org2}</span>
          </div>
        </div>

        <div className="mt-16 border-t border-sand/15 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-sand/50">
          <div className="flex items-center gap-2">
            <span className="flex h-7 w-7 items-center justify-center bg-terracotta text-sand">
              <Heart className="h-3.5 w-3.5" fill="currentColor" />
            </span>
            <span className="font-serif text-lg text-sand">Venezuela Earthquake Relief</span>
          </div>
          <p>{F.bottomOrg}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
